var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "url(#paint0_linear_702_1795)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3667 14.7183C25.1863 14.0422 24.6538 13.5097 23.9795 13.3293C22.7551 13 17.8471 13 17.8471 13C17.8471 13 12.9392 13 11.7148 13.3275C11.0387 13.508 10.508 14.0404 10.3275 14.7166C10 15.9427 10 18.5 10 18.5C10 18.5 10 21.0573 10.3275 22.2817C10.508 22.9578 11.0404 23.4903 11.7148 23.6707C12.9392 24 17.8471 24 17.8471 24C17.8471 24 22.7551 24 23.9795 23.6707C24.6556 23.4903 25.1863 22.9578 25.3667 22.2817C25.6943 21.0573 25.6943 18.5 25.6943 18.5C25.6943 18.5 25.6943 15.9427 25.3667 14.7183ZM16.2882 20.8471V16.1529L20.3519 18.4825L16.2882 20.8471Z",
    fill: "#E6DAFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_1795",
    x1: 0,
    y1: 18,
    x2: 36,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353148"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.94db2d621aa1c8e2dfdf7c50a083676b.svg";
export { ForwardRef as ReactComponent };